import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataConclusao = (): TabelaColuna => ({
  Chave: 'dataFimCurso',
  Texto: 'Data Conclusão',
  StyleColuna: { width: 100, paddingInline: 10 },
  Renderizar: (linha: TabelaDados) => (
    <>{formatadores.dataLocaleString(linha.dataFimCurso)}</>
  )
})
